<label [htmlFor]="htmlFor()" class="text-[0.85rem] text-gray-500">
  {{ value() | locale }}
  @if (required()) {
  <span>*</span>
  }
</label>
